import { Component } from '@angular/core';

@Component({
  selector: 'rs-accounts-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {}
